import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { checkPdiEligibility, fetchBrands, getPreDeliveryInspectionPrice, getVehicleDetail } from "../pre-delivery-inspection/actions";
import { setFormActiveScreen, setDetails } from "../pre-delivery-inspection-lead-form-parent/actions";
import { withRouter } from "react-router";

const mapStateToProps = ({
    brands: { popular: popularBrands },
    preDeliveryInspectionLeadData: { brand, newCarPdiLead },
    preDeliveryInspection: {priceDetails, isSsr}
}) => {
    return {
        popularBrands,
        brand,
        priceDetails,
        isSsr,
        newCarPdiLead
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchBrandsConnect: fetchBrands,
            setFormActiveScreenConnect: setFormActiveScreen,
            setDetailsConnect: setDetails,
            getVehicleDetailConnect: getVehicleDetail,
            getPreDeliveryInspectionPriceConnect: getPreDeliveryInspectionPrice,
            checkPdiEligibilityConnect: checkPdiEligibility
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
